import {useEffect} from "react";
import { useLocation } from "react-router-dom";

import { scrollPageToTop } from "../GetUrlParams";

 export const ScrollToTop = ({children}:any) => {
    const { pathname } = useLocation();
     useEffect(() => {
         // NOT window.scrollTo: standalone (rent.24rent.fi / the launcher app's
         // WebView) `#r24-App-Main` is pinned to 100vh, so the document never
         // scrolls and `.pageContainer` is the real scroller.
         scrollPageToTop();
     }, [pathname]);

    return children;
}